import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IHttpCreateFolderPayload } from '../../../action/http.action';

export const httpCreateFolder = (name: string) => returnAction<IHttpCreateFolderPayload>(ActionEnum.HTTP_CREATE_FOLDER, {
  name
});
